const roleDetail = (state = {}, action) => {
  switch (action.type) {
    case "roleDetail":
      return action.payload;
    default:
      return state;
  }
};

export default roleDetail;
